/**
 * HCE: one-tap add-to-cart for product grids.
 *
 * Previously this lived inline and duplicated verbatim in two sections
 * (hce-collection-shop and hce-featured-products), guarded by a
 * `typeof window.hceQuickAdd !== 'function'` check so whichever section
 * rendered first silently won. Consolidated here so there is one copy.
 *
 * Three real defects are fixed relative to that version:
 *   - failures were swallowed by an empty `.catch()`, so an out-of-stock or
 *     network error looked identical to success: the button simply un-dimmed
 *   - the cart badge is only rendered by Liquid when the cart is already
 *     non-empty, so the first add of a session updated nothing visible until
 *     the next page load. It is now created on demand.
 *   - there was no success feedback of any kind.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /** Update the header count, creating the badge if Liquid never rendered one. */
  function updateCartCount(count) {
    var anchor = document.getElementById('cart-icon-bubble');
    if (!anchor) return;

    var bubble = anchor.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      anchor.appendChild(bubble);
    }

    var visible = bubble.querySelector('span[aria-hidden]');
    var spoken = bubble.querySelector('.visually-hidden');
    // Shopify's own markup omits the number past 99; match that.
    if (visible) visible.textContent = count < 100 ? count : '';
    if (spoken) spoken.textContent = count + (count === 1 ? ' item' : ' items');
  }

  function flashAdded(btn) {
    btn.classList.add('is-added');
    setTimeout(function () {
      btn.classList.remove('is-added');
    }, 1400);
  }

  window.hceQuickAdd = function (event, btn) {
    event.preventDefault();
    event.stopPropagation();

    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.dataset.loading) return;

    btn.dataset.loading = '1';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (response) {
        // cart/add.js answers 422 with a JSON body for the cases that actually
        // matter to a shopper (sold out, quantity unavailable). Surface it.
        return response.json().then(function (body) {
          if (!response.ok) {
            throw new Error(body.description || body.message || 'Could not add this to your cart.');
          }
          return body;
        });
      })
      .then(function (added) {
        return fetch(root() + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            flashAdded(btn);

            var title = (added.items && added.items[0] && added.items[0].product_title) || added.product_title;
            if (window.hceToast) {
              window.hceToast(title ? title + ' added to your cart' : 'Added to your cart', {
                variant: 'success',
                action: { label: 'View cart', href: root() + 'cart' }
              });
            }
          });
      })
      .catch(function (error) {
        if (window.hceToast) {
          window.hceToast(error.message || 'Could not add this to your cart.', { variant: 'error' });
        }
      })
      .finally(function () {
        btn.dataset.loading = '';
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  };
})();
